import { z } from "zod";

export const invoiceItemSchema = z.object({
	id: z.string().optional().nullable(),
	quantity: z.string(),
	unit_of_measurement: z.string(),
	item_description: z.string(),
	unit_price: z.string(),
	total_price: z.string(),
	created_at: z.string().optional(),
});

export const invoiceSchema = z.object({
	id: z.string().optional().nullable(),
	sold_to: z.string(),
	tin_number: z.string(),
	address: z.string(),
	reference_number: z.string(),
	invoice_number: z.string(),
	invoice_date: z.string().datetime().or(z.string().date()).or(z.date()),
	terms: z.string(),
	order_reference_number: z.string(),
	prepared_by: z.string(),
	approved_by: z.string(),
	items: z.array(invoiceItemSchema).optional(),
	vatable_sales: z.number().nullable().optional(),
	vat_exempt: z.number().nullable().optional(),
	zero_rated: z.number().nullable().optional(),
	total_sales: z.number().nullable().optional(),
	withholding_tax: z.number().nullable().optional(),
	vat: z.number().nullable().optional(),
	total_amount_due: z.number().nullable().optional(),
	status: z.string().optional().nullable(),
	collection_status: z.string().optional().nullable(),
	amount_collected: z.union([z.string(), z.number()]).nullable().optional(),
	cancelled_at: z.string().nullable().optional(),
	cancelled_by: z.string().nullable().optional(),
	cancellation_reason: z.string().nullable().optional(),
	is_cancelled: z.boolean().optional(),
	books_cancellation_reversal_id: z.string().nullable().optional(),
	books_cancellation_reclassify_id: z.string().nullable().optional(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
});

export type Invoice = z.infer<typeof invoiceSchema>;

export interface InvoiceJournalLine {
	purpose?: string | null;
	account_code: string;
	account_name: string;
	description: string;
	debit: number;
	credit: number;
	tax_code: string | null;
}

export interface InvoiceJournalItems {
	entry_date: string | null;
	status: string;
	lines: InvoiceJournalLine[];
	total_debit: number;
	total_credit: number;
	is_balanced: boolean;
	is_custom?: boolean;
	entry_number?: string | null;
	books_entry_id?: string | null;
	posted_at?: string | null;
	last_error?: string | null;
	invoice_id?: string | null;
	has_invoice?: boolean;
}
